/**
 * IP module route name constants
 * Centralized route names to avoid hardcoded strings and improve maintainability
 */
export const IP_ROUTE_NAMES = {
    IP_LEGACY: 'ip-legacy',
    IP_HOME: 'ip-home',
    IP_PRICING: 'ip-pricing',
    AI_DRAFTING: 'ai-drafting',
    IP_PROFILE_EXTERNAL: 'ip-profile-external',
} as const;

// Type for route names
export type IpRouteName = typeof IP_ROUTE_NAMES[keyof typeof IP_ROUTE_NAMES];
